import { Config, Purchase } from "@cleeng/mediastore-sdk";
import axios from "axios";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logout from "../../../components/Logout";
import { API_URL } from "../../../constants";
import { axiosConfig, setExpiringItem, getExpiringItem, removeExpiringItem } from "../../../utils";

function CheckoutPage() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(search);
  const offerId = query.get("offerId");
  const couponCode = query.get("couponCode");
  // Detect if user is coming from the app via ?fromApp=true and persist in localStorage
  const fromAppParam = query.get("fromApp");
  React.useEffect(() => {
    if (fromAppParam === "true") {
      setExpiringItem("fromApp", true); // 2 hours default
    } else if (fromAppParam === "false") {
      removeExpiringItem("fromApp");
    }
  }, [fromAppParam]);
  const fromApp = getExpiringItem("fromApp") === true;

  const handleSuccess = () => {
    navigate(`/my-account`);
  };
  const host = window.location.origin;
  
  useEffect(() => {
    Config.setMyAccountUrl(`${host}/my-account`); // required for legal notes
    Config.setCheckoutPayPalUrls({
      // PayPal redirection URLs, required for PayPal payment
      successUrl: `${host}/my-account`,
      cancelUrl: `${host}/choose-plan`,
      errorUrl: `${host}/choose-plan`,
    });
  }, [host])

  const order = useSelector(state => state.order)
  const getOffers = React.useCallback(async () => {
    try {
      const res = await axios.get(
        `${API_URL}/offers?status=active&pageLimit=3`,
        axiosConfig(),
      );

      const listPlans = (res && res.data && res.data.responseData) || [];
      return listPlans;
    } catch (error) {
    }
  }, []);
  const isElementLoaded = async (selector, size = 1) => {
    while (document.querySelectorAll(selector).length < size) {
      await new Promise(resolve => requestAnimationFrame(resolve))
    }
    return document.querySelectorAll(selector);
  };

  const handleLoadImages = React.useCallback(async () => {
    const plansPromise = getOffers();
    const titleElements = isElementLoaded('.msd__subscription-card__icon')
    const [plans, selectors] = await Promise.all([plansPromise, titleElements])

    for (let index = 0; index < selectors.length; index++) {
      const selector = selectors[index];
      const offer = plans.find(o => offerId.includes(o.id))
      if (offer) {
        selector.style = `background-image: url("${offer.imageUrl}");background-size: cover;color: transparent;`
      }
    }
  }, [getOffers, offerId]);

  useEffect(() => {
    if (offerId) {
      handleLoadImages()
    }
  }, [offerId, order, handleLoadImages])
  return (
    <>
      <Logout />
      {fromApp ? (
        <div className="from-app-text">
          <p>
            You've navigated to this page from a mobile application. If you wish to subscribe, please do so through that app store. To manage a subscription that was purchased through the web application, see <a href="/my-account?fromApp=true">account management</a>.
          </p>
        </div>
      ) : (
        couponCode
          ? <Purchase key={offerId} offerId={offerId} couponCode={couponCode} onSuccess={handleSuccess} />
          : <Purchase key={offerId} offerId={offerId} onSuccess={handleSuccess} />
      )}
    </>
  );
}

export default CheckoutPage;
